/* eslint-disable react/prop-types */
import React, {useEffect,useState} from "react";

import { FiMapPin } from "react-icons/fi"
import {getLocationAirfare} from "_services/location.service";
import useDebounce from "hooks/useDebounce";

export default function SearchLocationAirfare({placeholder, disabled = false, location, onChange}) {

    const [search, setSearch] = useState('')
    const [loading, setLoading] = useState(false)
    const [displayValue, setDisplayValue] = useState(location?.name ?? '')
    const [open, setOpen] = useState(false)
    const [list, setList] = useState([])

    const debouncedChange = useDebounce(setSearch, 500, setLoading);

    const handleChange = (e) => {
        setLoading(true)
        e.target.value.length >= 3 && setOpen(true)
        setDisplayValue(e.target.value);
        debouncedChange(e.target.value);
    }

    useEffect(() => {
        const searchLocation = async () => {
            setLoading(true)
            const res = await getLocationAirfare(search);
            if(res.length){
                setList(res)
            }
        }

        if (search.length >= 3) {
            searchLocation().then(() => {
                setLoading(false)
            })
        }
    }, [search])

    const changeLocation = (params) => {
        onChange(params)
        setDisplayValue(params.name)
        setOpen(false)
    }

    return (
        <div className="dropdown">
            <div className="input-group">
                    <span className="input-group-custom ps-0">
                        <FiMapPin/>
                    </span>
                <input
                    className="form-control form-control-custom border-custom"
                    value={displayValue}
                    onChange={handleChange}
                    onClick={() => search.length >= 3 && setOpen(!open)}
                    placeholder={placeholder}
                    disabled={disabled}
                />
            </div>

            <ul className={`dropdown-menu w-100 ${open && 'show'}`}>
                {
                    loading ? <li className="text-center">Buscando...</li> :

                        list.length === 0
                            ? <li className="text-center">Nenhum local encontrado</li>

                            : list?.map((item, index) =>
                                <li key={index}>
                                    <a className="dropdown-item text-wrap" href="#"
                                       onClick={() => changeLocation(item)}>{item.name}</a>
                                </li>
                            )
                }
            </ul>
        </div>
    )
}
